import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { BasePage, PageType } from 'src/components/BasePage';
import { FormioForm } from 'src/components/FormioForm/FormioForm';
import { ApplicationsStore } from 'src/stores/ApplicationsStore/ApplicationsStore';
import styled from 'styled-components';

type ApplicationPageRouterParams = {
    applicationId: string;
};
export const ApplicationPage = observer(() => {
    const { params } = useRouteMatch<ApplicationPageRouterParams>();
    useEffect(() => {
        ApplicationsStore.loadItem(params.applicationId);
        ApplicationsStore.loadForm();
        () => {
            ApplicationsStore.itemLoader.reset();
            ApplicationsStore.formLoader.reset();
        };
    }, [params.applicationId]);

    const pageIsLoading =
        ApplicationsStore.itemLoader.isLoading ||
        ApplicationsStore.formLoader.isLoading;

    return (
        <StyledLoanPageWrapper>
            <BasePage
                pageName="application"
                isLoading={pageIsLoading}
                type={PageType.BASE}
            >
                <FormioForm
                    form={ApplicationsStore.currentItemForm as any}
                    submission={{
                        data: _.cloneDeep(ApplicationsStore.currentItem),
                    }}
                    onSubmit={() => {
                        return Promise.resolve();
                    }}
                    onCustomEvent={() => {
                        return Promise.resolve();
                    }}
                />
            </BasePage>
        </StyledLoanPageWrapper>
    );
});

const StyledLoanPageWrapper = styled.span`
    h2 {
        margin-left: 27px;
    }

    .header-panel {
        .row {
            justify-content: space-between;
        }
    }

    .input-as-status {
        margin-bottom: 37px;
        .disabledValueContainer {
            color: #ffffff !important;
        }
    }

    .loan-content-wrapper {
        padding: 0 27px;
    }
`;
